import { render, staticRenderFns } from "./ExibirServidores.vue?vue&type=template&id=44cb2fb5&scoped=true&"
import script from "./ExibirServidores.vue?vue&type=script&lang=js&"
export * from "./ExibirServidores.vue?vue&type=script&lang=js&"
import style0 from "./ExibirServidores.vue?vue&type=style&index=0&id=44cb2fb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb2fb5",
  null
  
)

export default component.exports